import React from 'react'

interface NoIconProps extends React.SVGProps<SVGSVGElement> {
  title?: string
}

export const NoIcon = (props: NoIconProps) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{props?.title}</title>
      <g clipPath="url(#clip0_12114_95096)">
        <path d="M1 1.19922H21V21.1992H1V1.19922Z" fill="#D72828" />
        <path d="M6 1.19922H11V21.1992H6V1.19922Z" fill="white" />
        <path d="M1 8.69922H21V13.6992H1V8.69922Z" fill="white" />
        <path d="M7.25 1.19922H9.75V21.1992H7.25V1.19922Z" fill="#002664" />
        <path d="M1 9.94922H21V12.4492H1V9.94922Z" fill="#002664" />
      </g>
      <path
        d="M11 0.699219C16.799 0.699219 21.5 5.40023 21.5 11.1992C21.5 16.9982 16.799 21.6992 11 21.6992C5.20101 21.6992 0.5 16.9982 0.5 11.1992C0.5 5.40023 5.20101 0.699219 11 0.699219Z"
        stroke="#D6D8DC"
      />
      <defs>
        <clipPath id="clip0_12114_95096">
          <path
            d="M1 11.1992C1 5.67637 5.47715 1.19922 11 1.19922C16.5228 1.19922 21 5.67637 21 11.1992C21 16.7221 16.5228 21.1992 11 21.1992C5.47715 21.1992 1 16.7221 1 11.1992Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
